import React, { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import format from "date-fns/format";
import { Calculate, GetAvailability, GetAvailableReservations } from "./api";
import Result from "./FastReservation/Result";
import SendBtn from "./FastReservation/SendBtn";
import FormDatepicker from "./FastReservation/FormDatepicker";
import Customer from "./FastReservation/Customer";
import ErrorComp from "./ErrorComp";
import ContactModal from "./ContactModal";
import { StoreContext } from "../context/context";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import useLocale from "../helper/useLocale";
import { useTranslation } from "../context/TranslationContext";
import PromotionCodeModal from "./PromotionCodeModal";
import ReservationUnavailable from "./ReservationUnavailable";
import Isitma from "./FastReservation/Isitma";
import differenceInDays from "date-fns/differenceInDays";
import AvailableDates from "./FastReservation/AvailableDates";
import { useExtraServices } from "../hooks/useExtraServices";
import KiralaGelBanner from "./KiralaGelBanner";

const FastReservation = ({
  id,
  setreservationResult = null,
  setParam = null,
  defaultState = null,
  useQueryDates = true,
  onSubmit = null,
  className = null,
  kisi = null,
  isActive = 1,
  paymentType,
  isAppWebView,
  deviceType,
}) => {
  const router = useRouter();
  const {
    reservationSubmitButtonText,
    notDates,
    appliedDiscount,
    ihaveapromotioncode,
    loadingDots,
    payNow,
  } = useTranslation();
  const localeData = useLocale();

  const { currentRoutingTypeId, page } = useContext(StoreContext);

  const [result, setResult] = useState(false);
  const [error, setError] = useState(false);
  const [warning, setWarning] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disabledDates, setDisabledDates] = useState([]);
  const [availableDatesModal, setAvailableDatesModal] = useState(false);
  const [availableDatesData, setAvailableDatesData] = useState([]);
  const { AvailableExtraServices } = result || {};
  let [isOpen, setIsOpen] = useState(false);

  const [selectedServices, setSelectedServices] = useState(
    router.query?.selectedServices
      ? new Set(router.query.selectedServices.split(","))
      : new Set(),
  );
  const [buyPool, setBuyPool] = useState(router.query?.buyPool == "1" ? 1 : 0);

  const [state2, setState2] = useState(
    defaultState
      ? defaultState
      : [
          {
            startDate:
              useQueryDates && router.query.start
                ? new Date(router.query.start)
                : new Date(),
            endDate:
              useQueryDates && router.query.end
                ? new Date(router.query.end)
                : new Date(),
            key: "selection",
            isShow: 0,
          },
        ],
  );

  const [customer, setCustomer] = useState([
    {
      yetiskin: router.query.yetiskin ? router.query.yetiskin : 1,
      cocuk: router.query.cocuk ? router.query.cocuk : 0,
      bebek: router.query.bebek ? router.query.bebek : 0,
    },
  ]);

  useEffect(() => {
    CalculateFunc();
  }, [state2, buyPool, selectedServices]);

  useEffect(() => {
    if (setParam) setParam({ buyPool: buyPool ? 1 : 0 });
  }, [buyPool]);

  useEffect(() => {
    if (setParam)
      setParam({ selectedServices: Array.from(selectedServices).join(",") });
  }, [selectedServices]);

  const CalculateFunc = () => {
    if (
      format(state2[0].startDate, "yyyy-MM-dd", { locale: localeData }) !==
      format(state2[0].endDate, "yyyy-MM-dd", { locale: localeData })
    ) {
      setIsLoading(true);
      Calculate({
        start: format(state2[0].startDate, "yyyy-MM-dd", {
          locale: localeData,
        }),
        end: format(state2[0].endDate, "yyyy-MM-dd", { locale: localeData }),
        EntityId: id,
        currentRoutingTypeId,
        PromotionCode:
          localStorage.getItem("PromotionCode") ||
          (isAppWebView ? "MobilApp.1000" : ""),
        pool_fee: buyPool ? 1 : 0,
        selectedServices: Array.from(selectedServices).join(","),
      })
        .then((response) => {
          setWarning(false);
          setError(false);
          if (
            router.query.disableRetryCalc == "true" &&
            !response?.data?.error
          ) {
            response.data.success = 200;
            response.data.disableRetryCalc = true;
          }
          setResult(response.data);
          if (setreservationResult) setreservationResult(response.data);

          if (response.data?.result?.isitmaHizmetDisi == "1") setBuyPool(0);

          response.data.error ? setError(response.data.error) : setError(false);
          response.data.warning
            ? setWarning(response.data.warning)
            : setWarning(false);
        })
        .finally(() => {
          setIsLoading(false);
        })
        .catch((error) => {
          setError(error.message);
        });
    }
    setParam &&
      setParam({
        start: format(state2[0].startDate, "yyyy-MM-dd", {
          locale: localeData,
        }),
        end: format(state2[0].endDate, "yyyy-MM-dd", { locale: localeData }),
      });
  };

  useEffect(() => {
    setParam &&
      setParam({
        yetiskin: customer[0].yetiskin,
        cocuk: customer[0].cocuk,
        bebek: customer[0].bebek,
      });
  }, [customer]);

  useEffect(() => {
    GetAvailability(id).then((e) => {
      setDisabledDates(e.data.data);
    });
    setResult(false);
  }, [id]);

  useEffect(() => {
    if (result?.ShowAvailableDates && result?.disableRetryCalc != true) {
      setAvailableDatesModal(true);
    } else {
      setAvailableDatesModal(false);
    }
  }, [result]);

  useEffect(() => {
    if (defaultState) setState2(defaultState);
  }, [defaultState]);

  useEffect(() => {
    setAvailableDatesData([]);

    if (availableDatesModal) {
      GetAvailableReservations({
        EntityId: id,
        start: format(state2[0].startDate, "yyyy-MM-dd"),
        end: format(state2[0].endDate, "yyyy-MM-dd"),
      }).then((e) => {
        if (e.data) {
          // Gelen veriyi Item1 alanına göre sıralayın
          const sortedData = [...e.data].sort(
            (a, b) => new Date(a.Item1) - new Date(b.Item1),
          );

          // Seçilen giriş tarihine en yakın olanı bulun ve işaretleyin
          const closestDate = findClosestDate(sortedData, state2[0].startDate);
          const updatedData = sortedData.map((item) =>
            item.Item1 === closestDate
              ? { ...item, isMostSuitable: true }
              : item,
          );

          // Sıralanmış ve işaretlenmiş veriyi set edin
          setAvailableDatesData(updatedData);
        }
      });
    }
  }, [availableDatesModal]);

  const findClosestDate = (dates, targetDate) => {
    if (dates.length > 0) {
      return dates.reduce((closest, current) => {
        const currentDiff = Math.abs(
          differenceInDays(new Date(current.Item1), new Date(targetDate)),
        );
        const closestDiff = Math.abs(
          differenceInDays(new Date(closest.Item1), new Date(targetDate)),
        );
        return currentDiff < closestDiff ? current : closest;
      }).Item1;
    }
    return null;
  };

  const submitForm = () => {
    if (
      format(state2[0].startDate, "yyyy-MM-dd", { locale: localeData }) ==
      format(state2[0].endDate, "yyyy-MM-dd", { locale: localeData })
    ) {
      setError(notDates);
    } else {
      if (onSubmit) onSubmit();
      router.push({
        pathname: "/" + page.Reservation.url,
        query: {
          ProductId: id,
          start: format(state2[0].startDate, "yyyy-MM-dd", {
            locale: localeData,
          }),
          end: format(state2[0].endDate, "yyyy-MM-dd", { locale: localeData }),
          yetiskin: customer[0].yetiskin,
          cocuk: customer[0].cocuk,
          bebek: customer[0].bebek,
          buyPool: buyPool ? 1 : 0,
          disableRetryCalc: result?.disableRetryCalc,
          selectedServices: Array.from(selectedServices).join(","),
        },
      });
    }
  };

  const { mandatoryServices, optionalServices, handleServiceChange } =
    useExtraServices(AvailableExtraServices, setSelectedServices);

  if (isActive == "0") {
    return <ReservationUnavailable />;
  }

  return (
    <>
      <FormDatepicker
        state2={state2}
        setState2={setState2}
        setError={setError}
        dates={disabledDates}
      />
      <div className="bg-detail-border-color h-0.5"></div>
      <Customer
        customer={customer}
        setCustomer={setCustomer}
        maxCapacity={kisi}
      ></Customer>

      {(page?.IsitmaVar == "1" || page?.Product?.IsitmaVar == "1") &&
        result.result &&
        result.result?.isitmaHizmetDisi != "1" && (
          <Isitma buyPool={buyPool} result={result} setBuyPool={setBuyPool} />
        )}

      <div
        className={
          "bg-white relative transition-opacity duration-200 " +
          (currentRoutingTypeId == "ProductDetail" ? "lg:p-3" : "") +
          " " +
          className +
          (isLoading ? " opacity-60 pointer-events-none" : "")
        }
      >
        {isLoading && (
          <div className="absolute inset-0 z-10 flex items-center justify-center">
            <div
              className="w-8 h-8 set-loading text-orange animate-spin rounded-full border-4 border-solid border-orange border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
              role="status"
            >
              <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                {loadingDots}
              </span>
            </div>
          </div>
        )}

        {result?.success && (
          <Result
            result={result}
            buyPool={buyPool}
            isLoading={isLoading}
            paymentType={paymentType}
            mandatoryServices={mandatoryServices}
            optionalServices={optionalServices}
            selectedServices={selectedServices}
            handleServiceChange={handleServiceChange}
            AvailableExtraServices={AvailableExtraServices}
            isAppWebView={isAppWebView}
          />
        )}
        {error && (
          <div className="p-2">
            <ErrorComp>{error}</ErrorComp>
          </div>
        )}
        {warning && (
          <div className="p-2">
            <ErrorComp type="warning">{warning}</ErrorComp>
          </div>
        )}

        {!error && currentRoutingTypeId != "Reservation" ? (
          <>
            <SendBtn submitForm={submitForm} disabled={error || !result}>
              {result?.BookableDirectly === "1"
                ? payNow
                : reservationSubmitButtonText}
            </SendBtn>
            <span
              className={`text-xs underline cursor-pointer `}
              onClick={() => setIsOpen(true)}
            >
              {localStorage.getItem("PromotionCode")
                ? appliedDiscount.replace(
                    "{code}",
                    localStorage.getItem("PromotionCode"),
                  )
                : ihaveapromotioncode}
            </span>
          </>
        ) : (
          ""
        )}
        <div className="sm:hidden">
          <KiralaGelBanner
            src="/images/kiralagel-banner/575x260.png"
            deviceType={deviceType}
          />
        </div>
        <PromotionCodeModal
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          CalculateFunc={CalculateFunc}
        />
        {result?.StopSell == 1 && (
          <ContactModal id={id} result={result}></ContactModal>
        )}
      </div>
      {availableDatesModal && (
        <>
          <div
            className="fixed inset-0 transition-opacity bg-black bg-opacity-50 z-[99998]"
            onClick={() => setAvailableDatesModal(false)}
          />
          <div
            className={`fixed flex items-center justify-center bg-white translate-y-full -translate-x-1/2 w-full sm:w-[600px] z-[99999] pb-4 bottom-0 border transition-[transform] duration-200 border-solid border-lightWhite-1100 rounded-t-20  left-1/2  text-black ${
              availableDatesModal ? "!translate-y-0" : ""
            } `}
          >
            <div className="relative overflow-hidden">
              <div className="relative flex flex-col items-center p-6 ">
                {availableDatesModal && (
                  <AvailableDates
                    availableDatesData={availableDatesData}
                    setAvailableDatesModal={setAvailableDatesModal}
                    error={error}
                    setError={setError}
                    result={result}
                    setResult={setResult}
                    total={state2}
                    setTotal={setState2}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default FastReservation;
